<div class="horizontal-card" [ngClass]="{ 'reverse' : card.reverse}">
    <img [src]="'assets/images/' + card.image">
    <div class="content">
        <div class="font-h4 title">{{card.title}}</div>
        <div class="font-body2" [innerHTML]="card.text"></div>
    </div>
</div>